import { APP_BASE_URL, APP_AGENT_URL } from '@/define/env';
export const getAbsolutePath = (relativePath) => `${APP_BASE_URL}${relativePath}`;
/**
 * TOP
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const topPath = () => '/';
/**
 * TOP（コンサルタント用）
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const forConsultantTopPath = () => '/for_consultant';
/**
 * ログイン
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const loginPath = () => `/login`;
/**
 * 新規登録
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const registrationPath = () => '/registration';
/**
 * 新規登録完了（企業）
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const registrationCompleteClientPath = () => '/registration/complete_client';
/**
 * 新規登録完了（コンサル）
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const registrationCompleteConsultantPath = () => '/registration/complete_consultant';
/**
 * パスワード再発行
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const passwordResetPath = () => '/password/reset';
/**
 * パスワード再発行完了画面
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const passwordResetRequestedPath = () => '/password/reset/requested';
/**
 * パスワード再設定完了
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const passwordResetCompletePath = () => '/password/reset/complete';
/**
 * パスワード初期設定完了
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const passwordSettingComplete = () => '/password/setting/complete';
/**
 * 名刺登録完了
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const cardComplete = () => '/card/complete';
/**
 * 会社概要
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const companyPath = () => '/company';
/**
 * 利用規約
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const termsPath = () => '/terms';
/**
 * PROFFIT SEARCH 利用規約
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const termsProffitSearchPath = () => '/terms_proffitsearch';
/**
 * 特定商取引法
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const lawPath = () => '/law';
/**
 * プライバシーポリシー
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const privacyPath = () => '/privacy';
/**
 * FAQ
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const faqPath = () => '/faq';
/**
 * コンサルサーチ検索TOP
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const consultantSearchTopPath = () => '/consultant';
/**
 * コンサルサーチ検索一覧
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const consultantSearchPath = () => '/consultant/search';
/**
 * コンサルサーチのPROFFIT SEARCH詳細画面
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const consultantSearchPSearchPath = (id) => `/consultant/proffit_search/${id}`;
/**
 * マイページ
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const myPagePath = () => '/mypage';
/**
 * プロフィール
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const profilePath = () => '/mypage/profile';
/**
 * プロジェクト事例 詳細
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const solutionOnePath = (id) => `/solutions/${id}`;
/**
 * コンサルタント プロフィール
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalsOnePath = (id) => `/consultant/${id}`;
/**
 * コンサルタント 会社詳細
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalUnitPath = (id) => `/consultant_unit/${id}`;
/**
 * フリーコンサルタント プロフィール
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const freeProfessionalOnePath = (id) => `/free_consultant/${id}`;
/**
 * クライアント マイページ
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const clientMyPageProjectPath = () => '/mypage/project';
/**
 * クライアント マイページ コンサルタント選定相談
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const clientMyPageConsultationPath = () => '/mypage/consultation';
/**
 * クライアント マイページ コンサルタント選定相談 確認画面
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const clientMyPageConsultationConfirmPath = () => '/mypage/consultation/confirm';
/**
 * クライアント 詳細（リダイレクト）
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const clientRfpOneRedirectPath = (id) => `/project/client/${id}`;
/**
 * クライアント 提案を集める
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const clientRfpOneOfferPath = (id) => `/project/client/${id}/offer`;
/**
 * クライアント 質問一覧
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const clientRfpOneQuestionPath = (id) => `/project/client/${id}/question`;
/**
 * クライアント 条件相談
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const clientRfpOneMessagePath = (id) => `/project/client/${id}/negotiate`;
/**
 * クライアント ファイル共有（一括送付）
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const clientRfpOneFileAllPath = (id) => `/project/client/${id}/file`;
/**
 * クライアント ファイル共有（一括送付確認）
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const clientRfpOneFileAllConfirmPath = (id) => `/project/client/${id}/file/confirm`;
/**
 * クライアント ファイル共有（個別ID：データなし）
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const clientRfpOneFileOneNoDataPath = (id) => `/project/client/${id}/file/no_message`;
/**
 * クライアント ファイル共有（個別ID）
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const clientRfpOneFileOnePath = (id, viewRequestId) => `/project/client/${id}/file/message/${viewRequestId}`;
/**
 * クライアント 面談先選定
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const clientRfpOneInterviewPath = (id) => `/project/client/${id}/interview`;
/**
 * コンサルタント 案件詳細
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalRfpOnePath = (id) => `/project/professional/${id}`;
/**
 * コンサルタント 案件質問追加編集
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalRfpQuestion = (id) => `/project/professional/${id}/question`;
/**
 * コンサルタント 案件質問追加編集
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalRfpQuestionAddPath = (id) => `/project/professional/${id}/question/add`;
/**
 * コンサルタント 案件条件相談
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalRfpNegotiatePath = (id) => `/project/professional/${id}/negotiate`;
/**
 * コンサルタント ファイル共有
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalRfpFilePath = (id) => `/project/professional/${id}/file/message`;
/**
 * コンサルタント 案件提出 Root
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalRfpOfferRootPath = (id) => `/project/professional/${id}/offer`;
/**
 * コンサルタント 案件提出入力
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalRfpOfferPath = (id) => `/project/professional/${id}/offer`;
/**
 * コンサルタント 案件提出入力（支払い）
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalRfpOfferPaymentPath = (id) => `/project/professional/${id}/offer/payment`;
/**
 * コンサルタント 案件提出確認
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalRfpOfferConfirmPath = (id) => `/project/professional/${id}/offer/confirm`;
/**
 * コンサルタント 案件提出完了
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalRfpOfferCompletePath = (id) => `/project/professional/${id}/offer/complete`;
/**
 * コンサルタント 案件提案詳細
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalRfpOfferedPath = (id) => `/project/professional/${id}/offered`;
/**
 * コンサルタント 案件一覧
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalRfpListPath = () => '/project/professional';
/**
 * クライアント マイページ コンサルタント招待
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalIntroduction = () => '/mypage/introductions';
/**
 * クライアント マイページ コンサルタント招待完了
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const professionalIntroductionComplete = () => '/mypage/introductions/complete';
/**
 * コラム
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const columnListPath = () => '/column';
/**
 * コラム詳細
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const columnOnePath = (weight, code) => `/column/${weight}/${code}`;
/**
 * ダウンロード資料一覧
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const documentListPath = () => '/document';
/**
 * ダウンロード資料詳細
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const documentOnePath = (weight, id) => `/document/${weight}/${id}`;
/**
 * ダウンロード資料DLページ
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const documentDownloadPath = (code) => `/document_download/${code}`;
// Search LP
export const searchLpPath = () => '/proffit_search/lp';
/**
 * セミナー 一覧
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const seminarListPath = () => `/seminar`;
/**
 * セミナー 申し込み
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const seminarOneRequest = (id) => `/seminar/${id}/request`;
/**
 * 選定支援事例 一覧
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const caseListPath = () => `/case`;
/**
 * 選定支援事例 詳細
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const caseOnePath = (id) => `/case/${id}`;
/**
 * 各種お問合わせ
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const contactPath = () => `/contact`;
/**
 * お問合せ: カジュアル相談会
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const contactCasualPath = () => `/contact/casual`;
/**
 * お問合せ: カジュアル相談会(確認)
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const contactCasualConfirmPath = () => `/contact/casual/confirm`;
/**
 * お問合せ: カジュアル相談会(完了)
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const contactCasualCompletePath = () => `/contact/casual/complete`;
/**
 * お問合せ: コンサル選定のご相談
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const contactConsultationPath = () => `/contact/consultation`;
/**
 * お問合せ: コンサル選定のご相談(確認)
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const contactConsultationConfirmPath = () => `/contact/consultation/confirm`;
/**
 * お問合せ: コンサル選定のご相談(完了)
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const contactConsultationCompletePath = () => `/contact/consultation/complete`;
/**
 * お問合せ: その他のお問合せ
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const contactOtherPath = () => `/contact/other`;
/**
 * お問合せ: その他のお問合せ(確認)
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const contactOtherConfirmPath = () => `/contact/other/confirm`;
/**
 * お問合せ: その他のお問合せ(完了)
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const contactOtherCompletePath = () => `/contact/other/complete`;
/**
 * ニュース一覧
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const releaseListPath = () => `/release`;
/**
 * ニュース詳細
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const releaseOnePath = (id) => `/release/${id}`;
/**
 * 404 リダイレクト用
 * @deprecated src/utils/router/pagePath.ts を使用
 */
export const notfoundPath = () => `/error/notfound`;
/*
 * =============================
 * 外部
 * =============================
 */
export const proffitAgentTop = () => APP_AGENT_URL;
